import React, { Suspense, lazy } from 'react';
import { HeroSection } from './components/HeroSection';
import { SocialProofBar } from './components/SocialProofBar';
// Below-the-fold sections are code-split and loaded on demand to keep the
// initial bundle (and LCP) small. fallback={null} avoids any layout shift.
const EarlyTestimonials = lazy(() => import('./components/EarlyTestimonials').then(m => ({
  default: m.EarlyTestimonials
})));
const PainBlock = lazy(() => import('./components/PainBlock').then(m => ({
  default: m.PainBlock
})));
const ProductReveal = lazy(() => import('./components/ProductReveal').then(m => ({
  default: m.ProductReveal
})));
const BonusesSection = lazy(() => import('./components/BonusesSection').then(m => ({
  default: m.BonusesSection
})));
const UrgencyCountdown = lazy(() => import('./components/UrgencyCountdown').then(m => ({
  default: m.UrgencyCountdown
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const ComparisonTable = lazy(() => import('./components/ComparisonTable').then(m => ({
  default: m.ComparisonTable
})));
const MoreTestimonials = lazy(() => import('./components/MoreTestimonials').then(m => ({
  default: m.MoreTestimonials
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FaqAccordion = lazy(() => import('./components/FaqAccordion').then(m => ({
  default: m.FaqAccordion
})));
const CostOfInaction = lazy(() => import('./components/CostOfInaction').then(m => ({
  default: m.CostOfInaction
})));
const FinalCta = lazy(() => import('./components/FinalCta').then(m => ({
  default: m.FinalCta
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const SocialProofToast = lazy(() => import('./components/SocialProofToast').then(m => ({
  default: m.SocialProofToast
})));
export function App() {
  return <div className="w-full min-h-screen bg-bg-primary" data-id="element-0">
      {/* Eager — above the fold */}
      <HeroSection data-id="element-1" />
      <SocialProofBar data-id="element-2" />

      {/* Lazy — below the fold */}
      <Suspense fallback={null} data-id="element-3">
        <EarlyTestimonials data-id="element-4" />
        <PainBlock data-id="element-5" />
        <ProductReveal data-id="element-6" />
        <BonusesSection data-id="element-7" />
        <UrgencyCountdown data-id="element-8" />
        <PricingSection data-id="element-9" />
        <ComparisonTable data-id="element-10" />
        <MoreTestimonials data-id="element-11" />
        <GuaranteeSection data-id="element-12" />
        <FaqAccordion data-id="element-13" />
        <CostOfInaction data-id="element-14" />
        <FinalCta data-id="element-15" />
        <Footer data-id="element-16" />
        <SocialProofToast data-id="element-17" />
      </Suspense>
    </div>;
}